
import { useState, useEffect } from "react";
import { VacationSearch } from "@/components/VacationSearch";
import { VacationResults } from "@/components/VacationResults";
import { AllVacations } from "@/components/AllVacations";
import { Deals } from "@/components/Deals";
import { Luxury } from "@/components/Luxury";
import { Rondreizen } from "@/components/Rondreizen";
import { SmartHomepageVacations } from "@/components/SmartHomepageVacations";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { LocalFavoritesContainer } from "@/components/local-favorites/LocalFavoritesContainer";
import { SEOManager } from "@/components/SEOManager";
import { useSearchManager } from "@/components/SearchManager";
import { useViewManager } from "@/components/ViewManager";

const Index = () => {
  const [searchResults, setSearchResults] = useState(null);
  const [currentQuery, setCurrentQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const { handleSearch } = useSearchManager();
  const {
    currentView,
    setCurrentView,
    handleShowAllVacations,
    handleShowDeals,
    handleShowLuxury,
    handleShowRondreizen,
    handleGoHome,
    handleGoBack
  } = useViewManager();

  // Listen for navigation messages from App.tsx
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'NAVIGATE_TO_VIEW') {
        const view = event.data.view;
        if (view === 'all') handleShowAllVacations();
        else if (view === 'deals') handleShowDeals();
        else if (view === 'luxury') handleShowLuxury();
        else if (view === 'rondreizen') handleShowRondreizen();
        else if (view === 'home') handleGoHome();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [handleShowAllVacations, handleShowDeals, handleShowLuxury, handleShowRondreizen, handleGoHome]);

  const onSearch = async (query: string) => {
    await handleSearch(query, setSearchResults, setCurrentQuery, setCurrentView, setLoading);
  };

  const handleShowThema = () => {
    window.location.href = '/thema';
  };

  const handleShowFavoritesComparison = () => {
    window.location.href = '/favorieten-vergelijken';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 flex flex-col">
      <SEOManager currentView={currentView} currentQuery={currentQuery} />
      
      <Header 
        onShowAllVacations={handleShowAllVacations}
        onShowDeals={handleShowDeals}
        onShowLuxury={handleShowLuxury}
        onShowRondreizen={handleShowRondreizen}
        onShowThema={handleShowThema}
        onShowFavoritesComparison={handleShowFavoritesComparison}
        onGoHome={handleGoHome}
        currentView={currentView}
      />
      
      <main className="flex-1">
        <div className="container mx-auto px-4 py-8">
          <div className="space-y-12">
            {currentView === 'home' && (
              <div className="space-y-12">
                <VacationSearch onSearch={onSearch} loading={loading} />
                <SmartHomepageVacations 
                  onShowDeals={handleShowDeals}
                  onShowLuxury={handleShowLuxury}
                  onShowRondreizen={handleShowRondreizen}
                  onShowAllVacations={handleShowAllVacations}
                />
              </div>
            )}
            
            {currentView === 'search' && searchResults && (
              <VacationResults 
                vacations={searchResults}
                searchQuery={currentQuery}
                onBack={handleGoBack}
                onSearch={onSearch}
                loading={loading}
              />
            )}
            
            {currentView === 'all' && <AllVacations onBack={handleGoBack} />}
            {currentView === 'deals' && <Deals onBack={handleGoBack} />}
            {currentView === 'luxury' && <Luxury onBack={handleGoBack} />}
            {currentView === 'rondreizen' && <Rondreizen onBack={handleGoBack} />}
          </div>
        </div>
      </main>
      
      <LocalFavoritesContainer />
      <Footer />
    </div>
  );
};

export default Index;
